import client from "./client";

export default {
    async getPlans() {
        return client.parseResponse(await client.get('/plans'));
    },

    async getCurrentPlan() {
        return client.parseResponse(await client.get('/business/plan'));
    },

    async upgradePlan(data) {
        return client.parseResponse(await client.post('/business/plan/upgrade', data));
    },
}
